module.exports = __webpack_public_path__ + "07_long_black.a2d54231.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/07_long_black.png
// module id = V2PG
// module chunks = 0